/* eslint-disable no-underscore-dangle */
import { logError } from 'commons/logger';

const handleProductClick = (algoliaMetaData = {}) => {
  const objectID = algoliaMetaData?.objectID;
  const queryID = algoliaMetaData?.queryID;

  const objectIDStr = objectID != null ? String(objectID).trim() : '';
  const queryIDStr = queryID != null ? String(queryID).trim() : '';
  const isValidObjectID = objectIDStr.length > 0;
  const isValidQueryID = queryIDStr.length > 0;

  if (!isValidObjectID || !isValidQueryID) return;

  const objectIDs = [objectIDStr];

  if (window.aa && window.algoliaInitialized) {
    window.aa('clickedObjectIDsAfterSearch', {
      eventName: 'Product Clicked',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs,
      positions: [algoliaMetaData?.position ?? 0],
      queryID: queryIDStr,
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleProductClick;
